<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
        

        <div v-if="images.length" class="columns is-multiline border-bottom">

            <div v-for="(x, index) in images" 
            :key="x" 
            class="column is-one-fifth has-text-centered over-this">
                <div class="insider">
                    <img  :src="x.image" class="displayImgs">
                    <div class="overlay">
                        <b-button
                        size="is-small"
                        type="is-danger is-small" 
                        rounded
                        @click="deleteBEImage(x.id, index)">
                            <b-icon 
                            class="p-0"
                            size="is-small" 
                            icon="times">
                            </b-icon>
                        </b-button>
                    </div>
                </div>
               
                <b-field>
                    <b-checkbox
                    v-model="x.default"
                    @input="imageSetAsDefault(x.id)">
                        <p>Imagen default</p>
                    </b-checkbox>
                </b-field>
                
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <h2><h2 class="has-text-weight-medium is-size-4">Add new images. </h2></h2>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <b-field >
                    <b-upload 
                        v-model="dropImages"
                        multiple
                        drag-drop
                        style="width:100%; display: block"
                        @input="why"
                        >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra tus fotos hasta aqui, o haz click.</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </div>
        </div>
        <div class="columns is-tablet is-multiline m-t-10 m-b-10">
            <div v-for="(x, index) in dropImagesDisplay" 
            :key="x" 
            class="column is-one-fifth has-text-centered over-this">
                <div class="insider">
                    <img :src="x" class="displayImgs">
                    <div class="overlay">
                        <b-button 
                        type="is-danger is-small" 
                        rounded
                        @click="deleteDropImage(index)">
                            <b-icon 
                            class="p-0" 
                            icon="times">
                            </b-icon>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column has-text-centered">
                <b-button 
                    type="is-primary" 
                    :loading="loadSave" 
                    rounded
                    @click="saveImages"
                    :disabled="disableSave">
                    <b-icon 
                        icon="save"
                        size="is-small">
                    </b-icon>
                    Save images
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import {getHandler, deleteHandler, postHandler, patchHandler} from "./../../../../services/http.js"

export default {
    props:{
        imagesList:{
            type:String,
            default:""
        },
        imagesCreate:{
            type:String,
            default:""
        },
        imagesDelete:{
            type:String,
            default:""
        },
        imagesUpdate:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            images:[],
            dropImages:[],
            loadSave:false,
            disableSave:false,
        }
    },
    methods:{
        why(){
            this.encodedImages
        },
        async imageSetAsDefault(id){
            var success = {
                resource:"notify"
            }
            var error = {
                resource:"notify"
            }
            var currentDefault = this.images.find(el=>{
                return el.default && el.id != id
            })
            var newDefaultImage = this.images.find(el => {
                return el.id == id
            })
            if (!currentDefault ){
                //Just update the new one.
                this.loading = true
                var update = await patchHandler(
                    this.imagesUpdate.replace('0000', newDefaultImage.id),
                    newDefaultImage,
                    {error:error, success:success}
                )
                this.loading = false
            }
            else if (id != currentDefault.id){
                //Update current (uncheck it) and new one.
                currentDefault.default = false
                this.loading = true
                var resp = await patchHandler(
                    this.imagesUpdate.replace('0000', currentDefault.id),
                    currentDefault,
                    {error:false, success:false}
                )
                var update = await patchHandler(
                    this.imagesUpdate.replace('0000', newDefaultImage.id),
                    newDefaultImage,
                    {error:error, success:success}
                )
                this.loading = false
            }
        },
        async fetchImages(){
            this.loading = true
            let response = await getHandler(this.imagesList, {error:false, success:false})
            this.images = response
            console.log(this.images)
            this.loading = false
        },
        async deleteBEImage(pk, index){
            this.loading=true
            let success = {
                resource:"notify",
                text:"The image has been deleted."
            }
            let err = {
                resource:"notify",
            }
            let url = this.imagesDelete.replace("0000", pk)
            let response = await deleteHandler(url, {error:err, success:success})
            this.images.splice(index, 1)
            this.loading = false
        },
        deleteDropImage(index){
            this.dropImages.splice(index, 1)
        },
        async saveImages(){
            let success = {
                resource:"notify",
                text:"The images are now saved!"
            }
            let err = {
                resource:"notify",
            }
            this.loadSave = true
            let response = await postHandler(this.imagesCreate, this.encodedImages, {error:err, success:success})
            this.loadSave = false
            if(response){
                this.fetchImages()
                this.dropImages = []
            }   
        },

    },
    computed:{
        dropImagesDisplay(){
            if(this.dropImages.length){
                let arr = []
               
                Array.from(this.dropImages).forEach(file => { 
                    
                    arr.push(
                        window.URL.createObjectURL(file)
                    )
                });
                return arr
            } 
            else {
                return null
            }
        },
        encodedImages(){
            if(this.dropImages.length){
                let arr = []
                Array.from(this.dropImages).forEach(file => { 
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    
                    reader.onloadend = (event) => {
                        
                        arr.push(
                            {image:reader.result}
                        )
                    }
                    
                    
                });
                return arr
            } 
            else {
                return null
            }

        }
        
    },
    created(){
        this.fetchImages()
    }

}
</script>

<style lang="scss" scoped>

.displayImgs{
   
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}

.displayImgsDropZone{
    border-radius: 10px;
    border: 0.8px #333  dotted;
}

.insider{
    width: 100%;
    max-height: 250px;
    display: block;
    position: relative;
}

.overlay{
    opacity: 0;
    transition: all .5s;
    position: absolute;
    z-index: 15000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    button{
        position:absolute;
        right:5px;
        top:5px;
    }
}
.insider:hover .overlay{
    opacity: 1;
}
.insider:focus .overlay{
    opacity: 1;
}

.border-bottom{
    border-bottom: 1px #ddd solid;
}
</style>
